import { render, staticRenderFns } from "./download-contacts-success-gray.svg?vue&type=template&id=86d044d8"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports